var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStoreBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_1829",
    "data-name": "Gruppe 1829",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.796,
    height: 37.37,
    viewBox: "0 0 111.796 37.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1826",
    "data-name": "Gruppe 1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1821",
    "data-name": "Gruppe 1821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1820",
    "data-name": "Gruppe 1820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4033",
    "data-name": "Pfad 4033",
    d: "M102.894,0H8.908c-.343,0-.681,0-1.023,0-.286,0-.57.007-.859.012A12.29,12.29,0,0,0,5.154.178,6.278,6.278,0,0,0,3.378.764a6.02,6.02,0,0,0-1.512,1.1A5.872,5.872,0,0,0,.765,3.38,6.189,6.189,0,0,0,.181,5.158a12.218,12.218,0,0,0-.167,1.87C.006,7.315,0,7.6,0,7.889v21.6c0,.29.006.571.014.86a12.2,12.2,0,0,0,.167,1.87,6.173,6.173,0,0,0,.584,1.78,5.823,5.823,0,0,0,1.1,1.508,5.885,5.885,0,0,0,1.512,1.1,6.255,6.255,0,0,0,1.776.589,12.413,12.413,0,0,0,1.872.165c.289.007.573.01.859.01.342,0,.68,0,1.023,0h93.986c.335,0,.676,0,1.013,0,.284,0,.576,0,.861-.01a12.259,12.259,0,0,0,1.868-.165,6.336,6.336,0,0,0,1.783-.589,5.9,5.9,0,0,0,1.511-1.1,5.989,5.989,0,0,0,1.1-1.508,6.19,6.19,0,0,0,.578-1.78,12.566,12.566,0,0,0,.173-1.87c0-.29,0-.571,0-.86.007-.34.007-.677.007-1.022V8.909c0-.342,0-.681-.007-1.02,0-.286,0-.574,0-.86a12.589,12.589,0,0,0-.173-1.87,6.207,6.207,0,0,0-.578-1.778A6.048,6.048,0,0,0,108.419.764a6.359,6.359,0,0,0-1.783-.586,12.139,12.139,0,0,0-1.868-.164c-.285,0-.577-.01-.861-.012-.336,0-.677,0-1.013,0Z",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4034",
    "data-name": "Pfad 4034",
    d: "M7.947,36.61c-.285,0-.562,0-.845-.01a11.79,11.79,0,0,1-1.747-.152,5.48,5.48,0,0,1-1.547-.512A5.02,5.02,0,0,1,2.5,34.986a4.979,4.979,0,0,1-.954-1.305,5.374,5.374,0,0,1-.507-1.548,11.573,11.573,0,0,1-.155-1.752c-.007-.2-.014-.853-.014-.853V7.946S.881,7.3.887,7.111a11.538,11.538,0,0,1,.154-1.749,5.349,5.349,0,0,1,.508-1.553A4.987,4.987,0,0,1,2.5,2.5a5.2,5.2,0,0,1,1.31-.956,5.436,5.436,0,0,1,1.544-.508A11.818,11.818,0,0,1,7.1.886L7.947.875h96.012l.853.012a11.547,11.547,0,0,1,1.736.151,5.561,5.561,0,0,1,1.561.512,5.225,5.225,0,0,1,2.256,2.261,5.361,5.361,0,0,1,.5,1.541,11.977,11.977,0,0,1,.163,1.763c0,.264,0,.549,0,.831.007.35.007.684.007,1.02V28.52c0,.339,0,.671-.007,1,0,.3,0,.582,0,.869a11.733,11.733,0,0,1-.16,1.731,5.345,5.345,0,0,1-.5,1.56,5.115,5.115,0,0,1-.948,1.295,5.034,5.034,0,0,1-1.308.955,5.448,5.448,0,0,1-1.558.514,11.641,11.641,0,0,1-1.746.152c-.274.007-.56.01-.838.01l-1.013,0Z",
    transform: "translate(-0.057 -0.058)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1825",
    "data-name": "Gruppe 1825",
    transform: "translate(9.316 8.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1823",
    "data-name": "Gruppe 1823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1822",
    "data-name": "Gruppe 1822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4035",
    "data-name": "Pfad 4035",
    d: "M23.8,19.885A4.623,4.623,0,0,1,26,16.006a4.73,4.73,0,0,0-3.729-2.016c-1.569-.164-3.09.939-3.889.939s-2.045-.923-3.371-.9a4.965,4.965,0,0,0-4.179,2.548c-1.807,3.129-.459,7.726,1.272,10.255.866,1.238,1.878,2.621,3.2,2.572,1.3-.054,1.78-.827,3.344-.827s2,.827,3.355.8c1.391-.023,2.266-1.244,3.1-2.494a10.235,10.235,0,0,0,1.418-2.889A4.467,4.467,0,0,1,23.8,19.885Z",
    transform: "translate(-9.972 -9.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4036",
    "data-name": "Pfad 4036",
    d: "M21.823,11.981A4.554,4.554,0,0,0,22.864,8.72a4.633,4.633,0,0,0-3,1.551,4.333,4.333,0,0,0-1.069,3.14A3.83,3.83,0,0,0,21.823,11.981Z",
    transform: "translate(-10.55 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1824",
    "data-name": "Gruppe 1824",
    transform: "translate(22.847 8.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4037",
    "data-name": "Pfad 4037",
    d: "M41.784,26.544H37.362L36.3,29.68H34.427l4.189-11.6h1.946l4.188,11.6h-1.9ZM37.82,25.1h3.505L39.6,20.008H39.55Z",
    transform: "translate(-34.427 -17.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4038",
    "data-name": "Pfad 4038",
    d: "M54.6,25.666c0,2.628-1.407,4.317-3.531,4.317a2.866,2.866,0,0,1-2.661-1.48h-.04v4.189H46.631V21.436h1.681v1.407h.032a3,3,0,0,1,2.693-1.495C53.184,21.348,54.6,23.045,54.6,25.666Zm-1.784,0c0-1.712-.886-2.838-2.236-2.838-1.327,0-2.219,1.149-2.219,2.838s.892,2.846,2.219,2.846C51.929,28.512,52.815,27.394,52.815,25.666Z",
    transform: "translate(-35.229 -18.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4039",
    "data-name": "Pfad 4039",
    d: "M64.564,25.666c0,2.628-1.407,4.317-3.531,4.317a2.866,2.866,0,0,1-2.661-1.48h-.04v4.189H56.6V21.436h1.681v1.407h.032A3,3,0,0,1,61,21.348C63.149,21.348,64.564,23.045,64.564,25.666Zm-1.785,0c0-1.712-.885-2.838-2.235-2.838-1.327,0-2.219,1.149-2.219,2.838s.892,2.846,2.219,2.846C61.894,28.512,62.779,27.394,62.779,25.666Z",
    transform: "translate(-35.885 -18.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4040",
    "data-name": "Pfad 4040",
    d: "M71.585,26.433c.129,1.151,1.246,1.906,2.774,1.906,1.464,0,2.517-.755,2.517-1.793,0-.9-.635-1.44-2.139-1.809l-1.5-.362c-2.13-.515-3.119-1.511-3.119-3.128,0-2,1.744-3.376,4.222-3.376,2.451,0,4.132,1.375,4.188,3.376H76.771c-.1-1.158-1.061-1.856-2.461-1.856s-2.355.707-2.355,1.736c0,.82.611,1.3,2.107,1.672l1.278.314c2.38.563,3.369,1.519,3.369,3.217,0,2.17-1.728,3.53-4.478,3.53-2.573,0-4.311-1.328-4.423-3.426Z",
    transform: "translate(-36.753 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4041",
    "data-name": "Pfad 4041",
    d: "M83.137,19.3v2h1.609v1.375H83.137v4.663c0,.725.322,1.062,1.03,1.062a5.327,5.327,0,0,0,.571-.04v1.367a4.748,4.748,0,0,1-.964.08c-1.712,0-2.38-.644-2.38-2.283V22.676H80.163V21.3h1.229v-2Z",
    transform: "translate(-37.434 -17.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4042",
    "data-name": "Pfad 4042",
    d: "M86.065,25.665c0-2.662,1.568-4.334,4.012-4.334S94.089,23,94.089,25.665,92.537,30,90.077,30,86.065,28.333,86.065,25.665Zm6.255,0c0-1.826-.836-2.9-2.243-2.9s-2.242,1.086-2.242,2.9.835,2.9,2.242,2.9S92.32,27.5,92.32,25.665Z",
    transform: "translate(-37.822 -18.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4043",
    "data-name": "Pfad 4043",
    d: "M96.186,21.436h1.656v1.44h.039a2.018,2.018,0,0,1,2.035-1.528,2.7,2.7,0,0,1,.6.064v1.624a2.448,2.448,0,0,0-.78-.1,1.75,1.75,0,0,0-1.81,1.946v5.017H96.186Z",
    transform: "translate(-38.488 -18.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4044",
    "data-name": "Pfad 4044",
    d: "M108.847,27.409c-.234,1.535-1.728,2.589-3.642,2.589-2.461,0-3.988-1.648-3.988-4.293s1.536-4.374,3.915-4.374c2.34,0,3.812,1.608,3.812,4.172v.6H102.97v.1a2.2,2.2,0,0,0,2.276,2.4,1.914,1.914,0,0,0,1.954-1.189Zm-5.869-2.524h4.228a2.034,2.034,0,0,0-2.074-2.147A2.142,2.142,0,0,0,102.978,24.885Z",
    transform: "translate(-38.818 -18.098)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1828",
    "data-name": "Gruppe 1828",
    transform: "translate(33.326 7.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1827",
    "data-name": "Gruppe 1827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4045",
    "data-name": "Pfad 4045",
    d: "M39.148,14.306H35.671V8.731h.866V13.51h2.611Z",
    transform: "translate(-35.671 -8.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4046",
    "data-name": "Pfad 4046",
    d: "M40.329,13.206c0-.757.564-1.194,1.565-1.256l1.14-.065v-.363c0-.444-.294-.7-.861-.7-.463,0-.785.17-.877.467h-.8c.085-.722.764-1.186,1.719-1.186,1.055,0,1.649.525,1.649,1.414V14.4h-.8V13.8H43a1.416,1.416,0,0,1-1.264.661A1.271,1.271,0,0,1,40.329,13.206Zm2.7-.359V12.5l-1.028.065c-.579.039-.842.236-.842.607s.328.6.78.6A.991.991,0,0,0,43.034,12.847Z",
    transform: "translate(-35.977 -8.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4047",
    "data-name": "Pfad 4047",
    d: "M45.276,12.181c0-1.329.684-2.171,1.747-2.171a1.386,1.386,0,0,1,1.289.738h.063V8.437h.83v5.849h-.8v-.665h-.065a1.459,1.459,0,0,1-1.321.734C45.952,14.355,45.276,13.514,45.276,12.181Zm.858,0c0,.892.421,1.429,1.124,1.429s1.132-.545,1.132-1.426-.436-1.429-1.132-1.429S46.134,11.3,46.134,12.181Z",
    transform: "translate(-36.303 -8.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4048",
    "data-name": "Pfad 4048",
    d: "M54.482,13.26a1.708,1.708,0,0,1-1.823,1.217,1.911,1.911,0,0,1-1.943-2.172,1.94,1.94,0,0,1,1.94-2.2c1.171,0,1.877.8,1.877,2.121v.29H51.562v.047a1.112,1.112,0,0,0,1.12,1.205,1.01,1.01,0,0,0,1-.51ZM51.562,11.9h2.125a1.016,1.016,0,0,0-1.036-1.09A1.077,1.077,0,0,0,51.562,11.9Z",
    transform: "translate(-36.66 -8.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4049",
    "data-name": "Pfad 4049",
    d: "M55.994,10.189h.8v.668h.062a1.26,1.26,0,0,1,1.256-.749,1.368,1.368,0,0,1,1.456,1.565V14.4h-.83V11.881c0-.676-.294-1.013-.908-1.013a.965.965,0,0,0-1,1.066V14.4h-.831Z",
    transform: "translate(-37.007 -8.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4050",
    "data-name": "Pfad 4050",
    d: "M63.52,8.827a.538.538,0,1,1,.537.506A.512.512,0,0,1,63.52,8.827Zm.123,1.244h.827v4.207h-.827Z",
    transform: "translate(-37.502 -8.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4051",
    "data-name": "Pfad 4051",
    d: "M65.971,10.189h.8v.675h.062a1.274,1.274,0,0,1,2.329,0h.066a1.366,1.366,0,0,1,1.279-.757A1.25,1.25,0,0,1,71.85,11.5v2.9h-.83V11.715c0-.568-.272-.846-.817-.846a.852.852,0,0,0-.888.881V14.4H68.5V11.634a.733.733,0,0,0-.811-.765.905.905,0,0,0-.888.955V14.4h-.831Z",
    transform: "translate(-37.663 -8.435)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/AppStore-Badge.38561badbd3cc80b45b6f8b9b0c1a99b.svg";
export { ForwardRef as ReactComponent };